"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
function randomInRange(min, max) {
    return Math.random() * (max - min) + min;
}
exports.default = randomInRange;
